module.exports = __webpack_public_path__ + "static/media/DIRAD.fa14a97d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/DIRAD.svg
// module id = 446
// module chunks = 0